import React from "react";
import CsvReader from "./CsvReader";

function PaymentsUpdater() {
  return (
    <>
      <CsvReader />
    </>
  );
}

export default PaymentsUpdater;
